import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaDollarSign,
  FaList,
  FaChartBar,
  FaMoneyCheck
} from 'react-icons/fa';

// Import components

import FournisseurEcheance from '../ReglementFournisseur/FournisseurEcheance';
import ReglementsList from '../ReglementClient/ReglementsList';
import ReglementForm from '../ReglementClient/ReglementForm';
import ReglementReport from '../ReglementClient/ReglementReport';
import ClientEcheance from '../ReglementClient/ClientEcheance';
import ReglementsFournisseurList from '../ReglementFournisseur/ReglementsFournisseurList';
import ReglementFournisseurForm from '../ReglementFournisseur/ReglementForm';

const FinanceModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'finance',
    title: t('modules.finance.title'),
    description: t('modules.finance.description'),
    icon: FaDollarSign,
    color: '#ffc107',
    menuItems: [
      { path: '/finance-module/payments', icon: FaList, label: t('nav.listeReglements') },
      { path: '/finance-module/payments/fournisseur', icon: FaList, label: t('nav.listeReglementsFournisseur') },
      { path: '/finance-module/client-deadlines', icon: FaMoneyCheck, label: t('nav.echeanceClient') },
      { path: '/finance-module/supplier-deadlines', icon: FaMoneyCheck, label: t('nav.echeanceFournisseur') }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/finance-module/payments" replace />} />
        <Route path="/payments" element={<ReglementsList />} />
        <Route path="/payments/fournisseur" element={<ReglementsFournisseurList />} />
        <Route path="/payments/edit" element={<ReglementForm />} />
        <Route path="/payments/new" element={<ReglementForm />} />
        <Route path="/payments/fournisseur/new" element={<ReglementFournisseurForm />} />
        <Route path="/payments/fournisseur/edit" element={<ReglementFournisseurForm />} />
        <Route path="/reports" element={<ReglementReport />} />
        <Route path="/client-deadlines" element={<ClientEcheance />} />
        <Route path="/supplier-deadlines" element={<FournisseurEcheance />} />
      </Routes>
    </ModuleLayout>
  );
};

export default FinanceModule;
